<template>
  <div id="wdc-app" :class="{ 'wdc-app': true, [theme]: theme }">
    <router-view v-if="excludeNavPage.includes($route.name)"></router-view>
    <template v-else>
      <tempNav :tempData="$store.state.dynamic" v-if="$store.state.dynamic.pageHeaderSetting == 1" ref="tempnav" />
      <junminNav v-else />
      <!-- <FixTop @backTop="backTop" /> -->
      <div ref="main" class="main" style="background-color:#fff;">
        <router-view :key="key" />
      </div>
    </template>
  </div>
</template>

<script>
import junminNav from "./view/head/crowd/module/junminNav";
import currentURL from '@/assets/commonjs/junmin-url'
import tempNav from './view/head/crowd/module/tempNav.vue'
import homeInfo from '@/assets/commonjs/home'

// import FixTop from '../src/view/head/crowd/module/fix-top.vue'
console.log(currentURL, 'yuanmi')
export default {
  data() {
    return {
      excludeNavPage: [
        "login",
        "register",
        "error",
        "video",
        "coursePlay",
        "teacherLive",
        "studentSee",
        "register-jz",
        "forget",
        "training_detail",
        "testPaper",
        "livePlayback",
        "register-mz",
        "personnel",
        "screen",
        "service-agreement",
        "privacy"
      ],
      homeInfo

    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },

    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    }
  },
  components: { junminNav, tempNav, },
  // components: { tempNav,FixTop },
  async created() { },
  async mounted() {
    document.addEventListener("visibilitychange", () => {
      var isHidden = document.hidden;
      if (!isHidden) {
        let localStorageId =
          localStorage.getItem("userInfo") &&
          JSON.parse(localStorage.getItem("userInfo")).accountId;
        let vuexId = this.$store.state.userInfo.accountId;
        if (localStorageId && vuexId && localStorageId !== vuexId) {
          //重新加载页面，保持账号同步
          // this.$router.replace('/')
          this.$router.go(0);
        }
      }
    });
    // 开放平台-请求学员数据
    localStorage.setItem("loginBy", 0);
  },
  methods: {
    backTop() {
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
  }
};
</script>

<style lang="stylus">
.backtop {
  overflow-y: scroll;
}

.flex {
  display: flex;
}

.lr-flex {
  justify-content: space-between;
}

.el-message {
  min-width: 150px;
}

.el-message.is-closable .el-message__content {
  padding-right: 36px;
}

/* 选项卡tabs样式修改 */
.common-page {
  .el-tabs {
    .el-tabs__nav-wrap::after {
      display: none;
    }

    .el-tabs__nav-scroll {
      .el-tabs__nav {
        .el-tabs__active-bar {
          display: none;
        }

        .el-tabs__item {
          padding: 0;
          margin: 24px 12px;
          font: 500 18px PingFangSC-Medium, PingFang SC;
          color: #333;

          &:hover {
            color: #1972FF !important;
          }
        }

        .is-active {
          color: #1972FF !important;
        }
      }
    }
  }
}

/* *一分栏  二分栏 选项卡  样式 */
div[data-comp-name='12-12'], div[data-comp-name='1-2'], div[data-comp-name='Tabs'] {
  width: 1200px;
  margin: 0 auto;
}
</style>
<style scoped lang="stylus" >
  .main{
    /deep/ .certificate{
        background-color: #f9f9fa!important;
      }
  
  }
</style>

